// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"96e5a85b","445":"755c8601","855":"01abaf58","868":"224d06fd"}[chunkId] + ".chunk.js";
};